import Link, { LinkProps } from "next/link";

const DesktopFilterColumnUI = ({
  chipsUI,
  filtersUI,
  clearAllHref,
}: {
  chipsUI: React.ReactNode;
  filtersUI: React.ReactNode;
  clearAllHref: LinkProps["href"];
}) => {
  return (
    <div className="hidden md:block">
      <div className="hidden text-xs md:flex justify-between items-center">
        <span className="font-extrabold uppercase">Filters</span>

        <Link href={clearAllHref} className="underline text-xs font-bold">
          clear all
        </Link>
      </div>

      <div
        className="mb-lg flex flex-wrap items-center gap-xs"
        data-testid="filter-chips"
      >
        {chipsUI}
      </div>
      {filtersUI}
    </div>
  );
};

export default DesktopFilterColumnUI;
